import React from 'react'
import { shallow } from 'enzyme'
import { DebtRow } from '../DebtRow'
import business from './testData/debtScheduleBusiness'

describe('<DebtRow />', () => {
  const noop = () => {}
  let wrapper, instance, props
  let loan = business.outstandingLoans[0]
  beforeEach(() => {
    props = {
      loan,
      loanTypeOptions: business.loanTypeOptions,
      onCancel: noop,
      monthsRemainingCutoff: 6,
      businessId: business.rid
    },
    wrapper = shallow(<DebtRow {...props} />)
    instance = wrapper.instance()
  })
  describe('#reset', () => {
    describe('when there is data stored in state', () => {
      beforeEach(() => {
        for (const [key, value] of Object.entries(props.loan)) {
          wrapper.setState({ [key]: value })
        }
      })
      it('resets refinance to false and all other fields to null', () => {
        instance.reset()
        expect(wrapper.state('debtType')).toBeNull()
        expect(wrapper.state('lender')).toBeNull()
        expect(wrapper.state('originationDate')).toBeNull()
        expect(wrapper.state('outstandingPrincipal')).toBeNull()
        expect(wrapper.state('minimumPayment')).toBeNull()
        expect(wrapper.state('monthsRemaining')).toBeNull()
        expect(wrapper.state('refinance')).toBeFalsy()
      })
    })
  })
  describe('#isSaveDisabled', () => {
    it('returns true when there is no loan data', () => {
      instance.reset()
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the debtType is not valid', () => {
      wrapper.setState({ debtType: 'test' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the origination date is invalid', () => {
      wrapper.setState({ originationDate: 'test' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the date is before 1998', () => {
      wrapper.setState({ originationDate: '02/1990' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the outstanding principal is not a valid number', () => {
      wrapper.setState({ outstandingPrincipal: 'this is not a number' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the outstanding principal is less than 1', () => {
      wrapper.setState({ outstandingPrincipal: 0 })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when lender is not a valid string', () => {
      wrapper.setState({ lender: 10 })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the lender is an empty string', () => {
      wrapper.setState({ lender: '' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the monthlyPayment is not a valid number', () => {
      wrapper.setState({ monthlyPayment: 'this is not a number' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when monthlyPayment is less than 0', () => {
      wrapper.setState({ monthlyPayment: -200 })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when monthsRemaining is not a valid number', () => {
      wrapper.setState({ monthsRemaining: 'this is not a number' })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
    it('returns true when the outstanding principal is less than 1', () => {
      wrapper.setState({ monthsRemaining: 0 })
      expect(instance.isSaveDisabled).toBeTruthy()
    })
  })

  describe('handlers', () => {
    describe('#onCancel', () => {
      it('calls the <DebtRow />\'s onCancel prop', () => {
        const mockOnCancel = jest.fn()
        wrapper.setProps({ onCancel: mockOnCancel })
        instance.onCancel()
        expect(mockOnCancel).toHaveBeenCalledTimes(1)
      })
    })
    describe('#onNumberChange', () => {
      it('should set the provided state key to the event\'s rawValue property', () => {
        const event = { target: { rawValue: 10.01 } }
        const key = 'outstandingPrincipal'
        instance.onNumberChange(event, key, 'float')
        expect(wrapper.state(key)).toEqual(event.target.rawValue)
      })
      it('should set the provided state key to the event\'s rawValue property', () => {
        const event = { target: { rawValue: 10 } }
        const key = 'monthsRemaining'
        instance.onNumberChange(event, key, 'int')
        expect(wrapper.state(key)).toEqual(event.target.rawValue)
      })
    })
    describe('#toggleDeleteModal', () => {
      describe('when isDeleteModalOpen is true', () => {
        beforeEach(() => wrapper.setState({ isDeleteModalOpen: true }))
        it('should change isDeleteModalOpen to false', () => {
          instance.toggleDeleteModal()
          expect(wrapper.state('isDeleteModalOpen')).toBeFalsy()
        })
      })
      describe('when isDeleteModalOpen is false', () => {
        beforeEach(() => wrapper.setState({ isDeleteModalOpen: false }))
        it('should change isDeleteModalOpen to true', () => {
          instance.toggleDeleteModal()
          expect(wrapper.state('isDeleteModalOpen')).toBeTruthy()
        })
      })
    })
    describe('#onDeleteClick', () => {
      it('calls toggleDeleteModal', () => {
        const toggleDeleteModalMock = jest.fn()
        instance.toggleDeleteModal = toggleDeleteModalMock
        instance.onDeleteClick()
        expect(toggleDeleteModalMock).toHaveBeenCalledTimes(1)
      })
    })
  })

  describe('#isNewDebt', () => {
    it('should return val', () => {
      expect(wrapper.instance().isNewDebt).toBeFalsy()
    })
  })

  describe('#isIncludedInDSCR', () => {
    it('should return true', () => {
      loan.refinance = true
      wrapper.setProps({ loan })
      expect(wrapper.instance().isIncludedInDSCR).toBeFalsy()
    })
    it('should return false', () => {
      expect(wrapper.instance().isIncludedInDSCR).toBeFalsy()
    })
  })

  describe('#paymentOptions', () => {
    it('should return array', () => {
      const array = wrapper.instance().paymentOptions
      expect(array).toBeTruthy()
      expect(array.length).toBe(4)
      expect(array[0][0]).toBe('Daily')
    })
  })

  describe('#onPaymentTypeChange', () => {
    it('should return array', () => {
      const event = {
        target: {
          value: 'weekly'
        }
      }
      wrapper.instance().onPaymentTypeChange(event)
      expect(wrapper.state('paymentFrequency')).toBe('weekly')
    })
  })

  describe('#renderPaymentTypes', () => {
    it('should return array', () => {
      const array = wrapper.instance().renderPaymentTypes()
      expect(array).toBeTruthy()
      expect(array.length).toBe(4)
    })
  })
})